import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Layout, { Container } from '../components/layout';
import { getCookie } from '../config/webStorage';
import { apiurl } from '../config/config';
import { Link } from 'react-router-dom';
import { Briefcase, ArrowRight, BarChart } from 'lucide-react'; 
import { motion } from 'framer-motion';

const jobTitleMap = {
  "10000001": "Copywriting",
  "10000002": "Logistic Specialist",
  "10000003": "HR Recruiter",
};

const OADashboard = () => {
  const [stats, setStats] = useState(null);
  const token = getCookie("swtoken");

  useEffect(() => {
    axios.post(`${apiurl}/api/online-application/getApplicationStats`, {}, {
      headers: { Authorization: `${token}` }
    })
    .then(response => setStats(response.data))
    .catch(error => console.error(error));
  }, [token]);

  return (
    <Layout>
      <Container>
        <div className="min-h-screen bg-gray-100 p-6">
          {/* Navbar */}
          <nav className="bg-blue-600 p-4 text-white text-lg font-semibold mb-6 rounded-lg shadow-md">
            <div className="flex items-center gap-2">
              <Briefcase className="w-6 h-6" />
              Job Dashboard
            </div>
          </nav>

          {/* Stats Section */}
          {stats && (
            <div className="mb-6 bg-white p-4 rounded-lg shadow flex flex-col gap-3">
              <div className="flex items-center gap-2 text-lg font-semibold text-gray-700">
                <BarChart className="w-5 h-5 text-blue-500" />
                Total Applications: {stats.totalCount}
              </div>
              <div className="flex gap-4 flex-wrap">
                {stats.statusCounts.map((s, idx) => (
                  <div key={idx} className="bg-blue-100 text-blue-800 px-3 py-1 rounded">
                    {s._id}: {s.count}
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Job List */}
          <div className="space-y-4">
            {stats?.jobCounts?.map((job, idx) => (
              <motion.div
                key={idx}
                className="flex justify-between items-center bg-white p-4 rounded-lg shadow hover:shadow-lg transition-shadow"
                whileHover={{ scale: 1.02 }}
              >
                <div className="flex items-center gap-3">
                  <Briefcase className="w-5 h-5 text-blue-500" />
                  <span className="text-gray-800 font-medium">
                    {job.title || jobTitleMap[job._id] || `Job ${job._id}`} ({job.count})
                  </span>
                </div>

                <Link
                  to={`/online-applications/${job?._id}`}
                  className="flex items-center gap-1 bg-green-500 text-white px-4 py-1 rounded hover:bg-green-600 transition"
                >
                  View Applications
                  <ArrowRight className="w-4 h-4" />
                </Link>
              </motion.div>
            ))}
          </div>
        </div>
      </Container>
    </Layout>
  );
};

export default OADashboard;